<div class="header-section">
    <h1 *ngIf="isEditMode">
        {{ 'aumico_ui_document_edit_form_title_edit' | i18next }}
    </h1>
    <h1 *ngIf="!isEditMode">
        {{ 'aumico_ui_document_edit_form_title_add' | i18next }}
    </h1>
    <span class="ham-icon icon" (click)="onCancelClick()">
        <i class="close-icon x-icon"></i>
    </span>
</div>
<div class="tab-navigation-section" *ngIf="!isEditMode">
    <ham-tab-navigation
        [navigationItems]="navigationItems"
        [tabsTitles]="tabsTitles"
        [style]="'underline-thin'"
        [color]="'primary'"
        (tabClick)="onTabClick($event)"
    ></ham-tab-navigation>
</div>
<div class="upload-section">
    <!-- Content based on edit mode and document type, or selected tab in create mode -->
    <div *ngIf="(!isEditMode && selectedTab === 0) || (isEditMode && isFileDocument)">
        <!-- File Upload Area -->
        <div
            class="upload-area"
            (drop)="onDrop($event)"
            (dragover)="onDragOver($event)"
            [class.has-file]="selectedFile || fileMetaData"
            [class.error]="fileExtensionError || fileRequiredError"
            [style.padding.px]="selectedFile ? '0' : '24'"
        >
            <!-- Show placeholder when no file is selected AND no existing file metadata -->
            <div *ngIf="!selectedFile && !fileMetaData" class="upload-placeholder">
                <span
                    hamIconShapes
                    class="icon"
                    icon="assets/hamIcons/upload-document.svg"
                    [variant]="'teal'"
                    [size]="'regular'"
                    [type]="'square'"
                    noHover="true"
                    *ngIf="!fileExtensionError && !fileRequiredError"
                ></span>
                <span
                    hamIconShapes
                    class="icon"
                    icon="assets/hamIcons/exclamation-outline.svg"
                    [variant]="'red-transparent'"
                    [size]="'regular'"
                    [type]="'square'"
                    noHover="true"
                    *ngIf="fileExtensionError || fileRequiredError"
                ></span>

                <!-- Error Messages -->
                <div *ngIf="fileExtensionError" class="error-message">
                    {{ 'aumico_ui_document_edit_form_file_upload_error_format' | i18next }}
                </div>
                <div *ngIf="fileRequiredError" class="error-message">
                    {{ 'aumico_ui_document_edit_form_file_required_error' | i18next }}
                </div>
                <p>{{ 'aumico_reports_project_upload_document_drag' | i18next }}</p>
                <input
                    type="file"
                    #fileInput
                    [accept]="acceptedExtensions.join(',')"
                    (change)="onFileUploadedChanged($event.target.files); resetFiles($event)"
                    style="display: none"
                />
                <span class="browse-button" (click)="fileInput.click()">{{
                    'aumico_reports_browse_files' | i18next
                }}</span>

                <p class="small" *ngIf="acceptedExtensions.length > 0">
                    {{ 'aumico_reports_project_upload_document_description' | i18next }}{{ acceptedExtensions }}
                </p>
                <p class="small" *ngIf="maxSizeInMb">
                    {{ 'aumico_reports_project_upload_document_details' | i18next }}
                </p>
            </div>

            <!-- Show file preview for newly selected files -->
            <div *ngIf="selectedFile" class="file-preview">
                <div class="file-info">
                    <span class="ham-icon icon">
                        <i class="file-icon x-icon"></i>
                    </span>
                    <div class="file-details">
                        <span class="file-name">{{ selectedFile.name }}</span>
                        <span class="file-size">{{ (selectedFile.size / 1024 / 1024).toFixed(2) }}MB</span>
                    </div>
                    <span class="ham-icon icon" style="align-self: flex-start; margin-top: 4px; flex: 2">
                        <i class="check-circle x-icon"></i>
                    </span>
                    <span class="ham-icon icon" (click)="removeSelectedFile()">
                        <i class="x-circle-filled-icon x-icon"></i>
                    </span>
                </div>
            </div>

            <!-- Show file info for existing file documents (edit mode) -->
            <div *ngIf="!selectedFile && fileMetaData && isEditMode" class="file-preview">
                <div class="file-info">
                    <span class="ham-icon icon">
                        <i class="file-icon x-icon"></i>
                    </span>
                    <div class="file-details">
                        <span class="file-name">{{ fileMetaData.name }}</span>
                        <span class="file-size">{{ (fileMetaData.size / 1024 / 1024).toFixed(2) }}MB</span>
                        <small style="color: var(--gray-500, #6b7280)">{{
                            'aumico_ui_document_edit_form_file_existing' | i18next
                        }}</small>
                    </div>
                    <!-- No remove button for existing files in edit mode -->
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="(!isEditMode && selectedTab === 1) || (isEditMode && isLinkDocument)">
        <div class="link-input-section">
            <label>{{ 'aumico_ui_document_edit_form_add_link_label' | i18next }}</label>
            <span
                class="ham-icon period-icon"
                hamTooltip="{{ 'aumico_ui_document_edit_form_add_link_tooltip' | i18next }}"
                [withArrow]="true"
                [backGroundHexColor]="'#1F2A37'"
                [tooltipClass]="'cpmm-period'"
            >
                <i class="info-outline-icon"></i>
            </span>
        </div>
        <input
            hamInput
            placeholder="{{ 'aumico_ui_document_edit_form_add_link_placeholder' | i18next }}"
            [(ngModel)]="externalLinkUrl"
            (input)="onUrlChange()"
            (blur)="onUrlBlur()"
        />

        <!-- Link validation errors -->
        <div *ngIf="urlRequiredError" class="error-message">
            {{ 'aumico_ui_document_edit_form_link_required_error' | i18next }}
        </div>
        <div *ngIf="urlValidationError" class="error-message">
            {{ 'aumico_ui_document_edit_form_link_validation_error' | i18next }}
        </div>
    </div>
    <hr />
    <input
        hamInput
        label="{{ 'aumico_ui_document_edit_form_name_placeholder' | i18next }}"
        placeholder="{{ 'aumico_ui_document_edit_form_name_placeholder' | i18next }}"
        [(ngModel)]="documentName"
        (input)="onNameChange()"
        [class.error]="nameRequiredError"
    />
</div>
<div class="permanent-file-section">
    <div class="permanent-file-toggle">
        <label>{{ 'aumico_ui_document_edit_form_set_as_permanent' | i18next }}</label>
        <span
            class="ham-icon period-icon"
            hamTooltip="{{ 'aumico_ui_document_edit_form_set_as_permanent_tooltip' | i18next }}"
            [withArrow]="true"
            [backGroundHexColor]="'#1F2A37'"
            [tooltipClass]="'cpmm-period'"
        >
            <i class="info-outline-icon"></i>
        </span>
        <ham-toggle [checked]="isPermanentFile" (changed)="onPermanentFileToggle($event)"></ham-toggle>
    </div>

    <div class="input" *ngIf="isPermanentFile">
        <app-date-picker-flyout
            [formControl]="expirationDateFormControl"
            [label]="'aumico_ui_document_edit_form_expiration_date_label' | i18next"
            [required]="false"
            [disabled]="false"
            [showError]="false"
            [errorMessage]="''"
            flyoutClass="expiration-date-flyout"
            (dateSelected)="updateDate($event)"
        ></app-date-picker-flyout>
    </div>
</div>
<div class="button-row">
    <ham-button variant="primary" size="md" (buttonClick)="onCancelClick()" outline="true">{{
        'aumico_ui_document_edit_form_cancel' | i18next
    }}</ham-button>
    <ham-button
        *ngIf="isEditMode"
        variant="primary"
        size="md"
        (buttonClick)="onUploadClick()"
        [disabled]="!isFormValid"
        >{{ 'aumico_ui_document_edit_form_save_changes' | i18next }}</ham-button
    >
    <ham-button
        *ngIf="!isEditMode && selectedTab === 0"
        variant="primary"
        size="md"
        (buttonClick)="onUploadClick()"
        [disabled]="!isFormValid"
        >{{ 'aumico_ui_document_edit_form_submit_add' | i18next }}</ham-button
    >
    <ham-button
        *ngIf="!isEditMode && selectedTab === 1"
        variant="primary"
        size="md"
        (buttonClick)="onUploadClick()"
        [disabled]="!isFormValid"
        >{{ 'aumico_ui_document_edit_form_submit_add_link' | i18next }}</ham-button
    >
</div>
